import React from 'react';
import styles from './W_PaymentDetails.module.css';
import C_PaySystems from '@/components/C_Collections/C_PaySystems/C_PaySystems';
import cn from 'classnames';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';

interface W_PaymentDetailsProps {
  date: string;
}

export default function W_PaymentDetails({ date }: W_PaymentDetailsProps) {
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);
  return (
    <div className={styles.wrapper}>
      <p className={cn(styles.title, 'text-p-7')}>
        {t('profileBilling.nextPaymentPrefix')} {date}
      </p>
      <C_PaySystems />
    </div>
  );
}
